import { FC } from "react";
import styled from "styled-components";
import { DownloadIcon } from "../../Icons";

const CardButtonAnexosWrapper = styled.div`
	padding: 5px;
	font-family: Livvic;
	font-style: normal;
	font-weight: 500;
	font-size: 12px;
	line-height: 165.5%;
	color: #002b49;
	background-color: #eaddfd;
	border-radius: 7px;
	padding-left: 10px;
	padding-right: 10px;
	display: flex;
	flex-direction: row;
	flex-wrap: nowrap;
	justify-content: flex-start;
	align-items: center;
	align-content: normal;
	gap: 7px;
	p {
		margin: 0px;
		padding: 3px;
	}
`;

interface CardButtonAnexosProps {
	label: string;
}

const CardButtonAnexos: FC<CardButtonAnexosProps> = ({ label }) => {
	return (
		<CardButtonAnexosWrapper>
			<DownloadIcon size={13} color="#002B49" />

			<p>{label}</p>
		</CardButtonAnexosWrapper>
	);
};

export default CardButtonAnexos;
